export const tr = {
    'ads-description': {
        one: '{count} reklam seçildi',
        some: '{count} reklam seçildi',
        many: '{count} reklam seçildi',
        none: '{count} reklam seçildi'
    },
    'button-accept': 'Değiştir',
    'change-parameter': 'Parametreyi değiştir',
    'change-placeholder': 'Alanın boş bırakılması parametreyi siler',
    'change-placeholder-value': 'Alanın boş bırakılması bu değeri siler',
    'change-value': 'Değeri değiştir',
    'edit-site-links': 'Hızlı bağlantıları düzenleyin',
    'target-parameters-placeholder': 'Sadece tam eşleşme aranıyor',
    'target-parameters-title': 'Bul\r',
    'text-info':
        'Parametre adlarını veya değerlerini değiştirebilirsiniz; bu işlem sırasında ana bağlantı değiştirilmez. Arama sadece tam eşleşmeye göre yapılır.',
    title: 'İzleme parametrelerini değiştir'
};
